export class FieldProcessor {
  constructor(storage, req, appProcessor, itemProcessor, pipeService) {
    this.storage = storage;
    this.req = req;
    this.appProcessor = appProcessor;
    this.itemProcessor = itemProcessor;
    this.pipeService = pipeService;
    this.fieldListeners();
  }

  deleteFieldApi(field_id) {
    return this.req.post({ url: "/api/app/delete-field", form: { field_id } });
  }

  async updatedFieldApi(app_id, fieldModel = {}) {
    const app = await this.appProcessor.getApp(app_id);
    const appToUpdate = {
      app_id,
      app_name: app.app_name,
      group_id: app.group_id,
      icon: app.icon,
      field_list: app.field_list.map((field) =>
        field.field_id == fieldModel.field_id
          ? { ...field, ...fieldModel }
          : field
      ),
      views_list: app.views_list,
    };
    return this.appProcessor.updateApp(appToUpdate);
  }

  setFieldValueApi(app_id, item_id, field_id, field_value) {
    const itemToUpdate = [
      {
        item_id,
        fields: [
          {
            field_id,
            field_value,
          },
        ],
      },
    ];
    return this.itemProcessor.updateItems(app_id, itemToUpdate);
  }

  deleteFieldInStorage(app_id, field_id) {
    const app = this.storage.getApp(app_id);
    app.field_list = app.field_list.filter(
      (field) => field.file_id != field_id
    );
    app.items_list = app.items_list.map((item) => {
      item.fields = item.fields.filter((field) => field.field_id != field_id);
      return item;
    });
    this.storage.updateApp(app);
    return true;
  }

  updateFieldInStorage(app_id, fieldModel) {
    const app = this.storage.getApp(app_id);
    app.field_list = app.field_list.map((field) =>
      field.field_id == fieldModel.field_id
        ? { ...field, ...fieldModel }
        : field
    );
    this.storage.updateApp(app);
    return fieldModel;
  }

  //This method was created for setFieldValue()
  //!!!!! 1) Change for each to for
  //!!!!! 2) Stop iteration after value has been found
  updateFieldValue(app_id, item_id, field_id, field_value) {
    const app = this.storage.getApp(app_id);
    app.items_list.forEach((item) => {
      if (item.item_id == item_id) {
        item.fields.forEach((field) => {
          if (field.field_id == field_id) {
            field.field_value = field_value;
            app.items_object[item.item_id][field.field_id] = field;
          }
        });
      }
    });
    this.storage.updateApp(app);
    return field_value;
  }

  async getField(app_id, field_id) {
    const app = await this.appProcessor.getApp(app_id);
    if(!app) return null;
    for(let i = 0; i < app.field_list.length; i++) {
      if(app.field_list[i].field_id == field_id) {
        return app.field_list[i];
      }
    }
    return null;
  }

  async getFieldIdByNameSpace(app_id, name_space) {
    const app = await this.appProcessor.getApp(app_id);
    if(!app) return null;
    for(let i = 0; i < app.field_list.length; i++) {
      if(app.field_list[i].name_space == name_space) {
        return app.field_list[i].field_id;
      }
    }
    return null;
  }

  //!!!!! Shou Be Renamed to  getFields() !!!!!!!
  async getFieldModels(app_id) {
    const app = await this.appProcessor.getApp(app_id);
    if(!app) return null
    return app.field_list;
  }

  //!!!!! Shou Be added fieldID argument !!!!!!!
  async updateField(app_id, fieldModel) {
    if (!app_id || !fieldModel) {
      return;
    }
    const newModel = await this.updatedFieldApi(app_id, fieldModel);
    return this.updateFieldInStorage(app_id, newModel);
  }

  async deleteField(app_id, field_id) {
    await this.deleteFieldApi(field_id);
    return this.deleteFieldInStorage(app_id, field_id);
  }

  //this method should alwaise return value if no value we return null
  async getFieldValue(app_id, item_id, field_id) {
    let fieldValue = null;
    const app = await this.appProcessor.getApp(app_id);
    
    try {
      fieldValue = app.items_object[item_id][field_id].field_value;
    } catch(err) {

    }

    return fieldValue;
  }

  async setFieldValue(app_id, item_id, field_id, field_value) {
    if (!app_id || !item_id || !field_id) {
      return;
    }
    await this.setFieldValueApi(app_id, item_id, field_id, field_value);
    return this.updateFieldValue(app_id, item_id, field_id, field_value);
  }

  fieldListeners() {
    this.pipeService.onRoot('gh_value_get', {}, async (event, data) => {
      if(data.app_id && data.item_id && data.field_id) {
        let field_value = await this.getFieldValue(data.app_id, data.item_id, data.field_id);
        this.pipeService.emit('gh_value_get', data, field_value);
      }
    });

    this.pipeService.onRoot('gh_value_set', {}, async (event, data) => {
      if(data.item_id) {
        this.setFieldValue(data.app_id, data.item_id, data.field_id, data.new_value);
        delete data.new_value;
      }
    });

    this.pipeService.onRoot('gh_model_get', {}, async (event, data) => {
      try {
        let field_model = await this.getField(data.app_id, data.field_id);
        this.pipeService.emit('gh_model_get', data, field_model)
      } catch (error) {
        console.log('Field model: ', error);
      }
    });

    this.pipeService.onRoot('gh_model_update', {}, async (event, data) => {
      let field_model = await this.updateField(data.app_id, data.field_model);
      this.pipeService.emit('gh_model_update', { app_id: data.app_id, field_id: data.field_id }, field_model);
    });

    this.pipeService.onRoot('gh_models_get', {}, async (event, data) => {
      let field_models = await this.getFieldModels(data.app_id);
      this.pipeService.emit('gh_models_get', data, field_models);
    });

    this.pipeService.onRoot('gh_model_delete', {}, async (event, data) => {
      let status = await this.deleteField(data.app_id, data.field_id);
      this.pipeService.emit('gh_model_delete', data, status);
    });
  }

}
